import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import breakpoints from 'static/script/utils/breakpoints';
import FeatureFeedbackService from 'static/script/app/data/feature-feedback-service';

function FeatureFeedback() {

    this._like = null;
    this._key = null;
    this._subtitle = null;
    this._title = null;

    this.defaultAttrs({
        overlay: '[data-feature-feedback-overlay]',
        container: '[data-feature-feedback-container]',
        like: '[data-feature-feedback-dialog-like]',
        dislike: '[data-feature-feedback-dialog-dislike]',
        likeLabel: '[data-feature-feedback-dialog-likelabel]',
        dislikeLabel: '[data-feature-feedback-dialog-dislikelabel]',
        cancel: '[data-feature-feedback-dialog-cancel]',
        submit: '[data-feature-feedback-dialog-submit]',
        subtitle: '[data-feature-feedback-dialog-subtitle]',
        title: '[data-feature-feedback-dialog-title]',
        comment: '[data-feature-feedback-dialog-comment]',
        dialog: '[data-feature-feedback-dialog]',
        isOkToContact: '[data-feature-feedback-dialog-isoktocontact]'
    });

    this._like = function () {
        this._like = true;
        this.select('container').removeClass('feature-feedback-status-dislike');
        this.select('container').addClass('feature-feedback-status-like');
        this.select('submit').removeAttr('disabled');
    };

    this._dislike = function () {
        this._like = false;
        this.select('container').removeClass('feature-feedback-status-like');
        this.select('container').addClass('feature-feedback-status-dislike');
        this.select('submit').removeAttr('disabled');
    };

    this._prompt = function (evt, payload) {
        this._clear();
        this._key = payload.key;
        this._subtitle = payload.subtitle;
        this._title = payload.title;
        this.select('subtitle').text(payload.subtitle);
        this.select('title').text(payload.title);
        this.select('likeLabel').text(payload.likeLabel || 'Bra');
        this.select('dislikeLabel').text(payload.dislikeLabel || 'Dåligt');

        this._goToStep1();
        this._setPosition(payload.position);
        this._showOverlay();
        this._showDialog();

        if (payload.cssClass) {
            this.$node.addClass(payload.cssClass);
        }
    };

    this._submit = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        let payload = {
            key: this._key,
            title: this._subtitle + ' ' + this._title,
            like: this._like,
            comment: this.select('comment').val(),
            breakpoint: breakpoints.getCurrent(),
            isOkToContact: this.select('isOkToContact').is(':checked')
        };
        this.trigger(document, 'data:feature-feedback:submit', payload);
        this._clear();
        this._goToStep2();
    };

    this._clear = function () {
        this._like = null;
        this._key = null;
        this._subtitle = null;
        this._title = null;
        this.select('container').removeClass('feature-feedback-status-dislike');
        this.select('container').removeClass('feature-feedback-status-like');
        this.select('submit').attr('disabled', 'disabled');
        this.select('comment').val('');
    };

    this._setPosition = function (defaultPosition) {
        let position = defaultPosition;
        let container = this.select('container');

        position = this._getCenterPosition();

        container.css({
            'top': position.top,
            'left': position.left
        });
    };

    this._showOverlay = function  () {
        this.select('overlay')
            .height(Math.max($(window).height(), $(document).height()))
            .show();
    };

    this._hideOverlay = function  () {
        this.select('overlay').hide();
    };

    this._showDialog = function () {
        this.select('container').css({ visibility: 'visible' });
    };

    this._hideDialog = function () {
        this.select('container').css({ visibility: 'hidden' });
    };

    this._hideAll = function () {
        this._hideDialog();
        this._hideOverlay();
    };

    this._isSmallScreen = function () {
        return !breakpoints.isVisible(breakpoints.large);
    };

    this._getCenterPosition = function () {
        return {
            top: $(window).scrollTop() + (($(window).height() / 2) - (this.select('container').outerHeight() / 2)),
            left: ($(window).width() / 2) - (this.select('container').outerWidth() / 2)
        };
    };

    this._cancel = function () {
        this._hideDialog();
        this._hideOverlay();
    };

    this._goToStep1 = function () {
        this.select('container').removeClass('feature-feedback-step2');
        this.select('container').addClass('feature-feedback-step1');
    };

    this._goToStep2 = function () {
        this.select('container').removeClass('feature-feedback-step1');
        this.select('container').addClass('feature-feedback-step2');

        window.setTimeout(function () {
            this._hideAll();
        }.bind(this), 1500);
    };

    this._closeStep2 = function () {
        if (this.select('container').hasClass('feature-feedback-step2')) {
            this._hideAll();
        }
    };

    this.after('initialize', function () {
        this.on('click', {
            like: this._like,
            dislike: this._dislike,
            cancel: this._cancel,
            overlay: this._cancel,
            submit: this._submit,
            dialog: this._closeStep2
        });
        this.on(document, 'ui:feature-feedback:prompt', this._prompt);
        FeatureFeedbackService.attachTo(document);
    });
}

export default defineComponent.component(FeatureFeedback);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/feature-feedback/feature-feedback.js